import client from './main-client';

export const sendDealApi = (data) => {
  client().post('/deal-email', data);
};
export const sendApprovalEmailApi = (data) => client().put('/deal-email', data);

export const checkDealEmailLimitApi = (data) => client().post('/deal-email?limit=check', data);
/* eslint-disable eol-last */
